'use client';

import { ComponentProps, FC, PropsWithChildren } from 'react';
import { useGetUser } from '@/queries/user';
import { FlagProvider } from '@unleash/nextjs';
import { bootstrap } from './constants';

const config: RequiredKeys<
  NonNullable<ComponentProps<typeof FlagProvider>['config']>,
  'context'
> = {
  url: process.env.NEXT_PUBLIC_UNLEASH_FRONTEND_API_URL,
  clientKey: process.env.NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN,
  appName: process.env.NEXT_PUBLIC_UNLEASH_APP_NAME,
  environment: process.env.NEXT_PUBLIC_UNLEASH_FRONTEND_ENVIRONMENT,
  refreshInterval: 120, // in seconds
  context: {},
  bootstrap,
  bootstrapOverride: false,
};

const UnleashContainer: FC<PropsWithChildren> = ({ children }) => {
  const { data } = useGetUser();
  config.context.userId = data?.nationalId;
  return <FlagProvider config={config}>{children}</FlagProvider>;
};

export default UnleashContainer;
